import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import WilliamHill from './WilliamHill';
import WHLogoIcon from './WHLogoIcon';
import { getAllowedAttributes } from '../../props-filters';
import './Logo.scss';

var Logo = function Logo(_ref) {
  var url = _ref.url,
      onClick = _ref.onClick,
      className = _ref.className,
      slot = _ref.slot,
      variant = _ref.variant,
      restProps = _objectWithoutProperties(_ref, ['url', 'onClick', 'className', 'slot', 'variant']);

  return React.createElement(
    'a',
    _extends({
      className: cx('sb-header-logo', variant === 'mobile' ? 'sb-header-logo--mobile' : '', className),
      href: url,
      onClick: onClick
    }, getAllowedAttributes(restProps)),
    variant === 'mobile' ? React.createElement(
      'span',
      { className: 'sb-header-logo__image sb-header-logo__image--mobile' },
      React.createElement(WHLogoIcon, { key: 'kraken.logo.mobile' })
    ) : React.createElement(
      'span',
      { className: 'sb-header-logo__image' },
      React.createElement(WilliamHill, { key: 'kraken.logo.desktop' })
    )
  );
};

Logo.propTypes = {
  slot: PropTypes.oneOf(['logo']),
  url: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  variant: PropTypes.string
};

export default Logo;
//# sourceMappingURL=Logo.js.map